import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function UserMenu() {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const dropdownRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('userC')) || {};
  //const profilePic = user.picture || 'https://via.placeholder.com/40';
  const profilePic = user.picture;

  const handleLogout = () => {
    localStorage.clear();
    setShowMenu(false); // Hide menu
    navigate('/login');
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleProfileClick = () => {
    setShowMenu(false);
    navigate('/profile');
  };

  const handleSettingsClick = () => {
    setShowMenu(false);
    alert('Settings page coming soon');
  };

  return (
    <div style={{ position: 'relative' }} ref={dropdownRef}>
      <img
        src={profilePic}
        alt="User"
        onClick={() => setShowMenu(prev => !prev)}
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          cursor: 'pointer',
          border: '2px solid #ccc'
        }}
      />
      {showMenu && (
        <div
          style={{
            position: 'left',
            top: '50px',
            right: 0,
            backgroundColor: '#fff',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
            width: '160px',
            zIndex: 10
          }}
        >
          <button onClick={handleProfileClick} style={menuItemStyle}>👤 Profile</button>
          <button onClick={handleSettingsClick} style={menuItemStyle}>⚙️ Settings</button>
          <button onClick={handleLogout} style={{ ...menuItemStyle, color: 'red' }}>🚪 Logout</button>
        </div>
      )}
    </div>
  );
}

const menuItemStyle = {
  display: 'block',
  padding: '10px 15px',
  width: '100%',
  textAlign: 'left',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '14px',
};

export default UserMenu;
